// 늦게 온 옛 응답이 새 값을 덮지 않게 한다
//
// ── 왜 필요해졌는가 ─────────────────────────────────────────────────────────
//
// 2026-09-28 에 명부 읽기(`GET /api/rosters`)가 서버 잠금 밖으로 나갔다(`src/db/client.ts` 의
// readSnapshot). 연맹원 스물이 한꺼번에 다시 붙을 때 방송마다 쌓이는 명부 읽기가 잠금 줄을
// 넘쳤기 때문이다. 잠금 안에서는 읽기와 쓰기가 한 줄에 서서 응답이 커밋 순서대로 나갔는데,
// 잠금 밖에서는 먼저 보낸 읽기의 옛 응답이 나중 읽기의 새 응답이나 방송보다 늦게 올 수 있다.
// 그대로 쓰면 옛 값이 다음 방송까지 화면에 남는다.
//
// 시퀀스 읽기는 잠금 안에 남았지만 같은 일이 생긴다. 응답은 HTTP 로, 방송은 소켓으로 따로
// 오므로 브라우저가 받는 순서는 서버가 보낸 순서를 약속하지 않는다.
//
// ── 규칙 ────────────────────────────────────────────────────────────────────
//
// 읽기마다 번호를 받고(`issue`), **이미 쓴 것보다 새 번호일 때만** 쓴다(`accept`). 방송이 값을
// 통째로 가져오면 그때까지 보낸 읽기를 모두 쓴 것으로 친다(`supersede`).
//
// 「마지막에 보낸 읽기만 쓴다」로 하지 않은 이유: 처음에 그렇게 했더니 마지막 읽기가 실패하면
// 앞서 성공한 응답까지 버려져, 화면이 다음 방송까지 빈 명부로 남았다(같은 날 적대 검토 지적).
// 「쓴 것보다 새것만」은 실패한 읽기를 건너뛰고 성공한 것 중 가장 새것을 남긴다.

/** 한 종류의 읽기에 붙는 번호표. 훅마다 `useRef` 로 하나씩 들고 있는다. */
export interface ReadOrder {
  issued: number
  applied: number
}

export function newReadOrder(): ReadOrder {
  return { issued: 0, applied: 0 }
}

/** 읽기를 보내기 직전에 부른다. 돌려받은 번호를 응답과 함께 `accept` 에 넘긴다. */
export function issue(order: ReadOrder): number {
  order.issued += 1
  return order.issued
}

/** 이 번호의 응답을 화면에 써도 되는가. 참이면 쓴 것으로 기록한다. */
export function accept(order: ReadOrder, ticket: number): boolean {
  if (ticket <= order.applied) return false
  order.applied = ticket
  return true
}

/** 방송이 값을 통째로 가져왔다. 지금까지 보낸 읽기의 응답은 전부 그보다 옛것으로 친다. */
export function supersede(order: ReadOrder): void {
  order.issued += 1
  order.applied = order.issued
}
